import Back from '@/assets/img/back-arrow.png';
export type Props = {
  onBackClick?: () => void;
  screenTitle:string
};
export const SimpleHeader = ({ onBackClick ,screenTitle}: Props) => {


  const getPathname = () => {
    if(window.location.pathname == '/login' && screenTitle == 'Profile' ){
      return false
    }else {
      return true
    }
  }

  return (
    <>
    { <div className="header-comp">
      { getPathname() &&   <img
        alt="back"
        onClick={() => {
          if (onBackClick) {
            onBackClick();
          }
        }}
        src={Back}
        className="profile-back-arrow"
      />}
      <div className={screenTitle == 'Sign Up' ||  screenTitle== 'Login' || screenTitle== 'Profile' ? "header-title": 'header-title-small'}>{getPathname() ? screenTitle: ''}</div>
    </div>}
    </>
  );
};
